export const EnvironmentValues = ['local', 'dev', 'stage', 'prod'] as const;
export type Environment = (typeof EnvironmentValues)[number];

export const isEnvironmentValue = (value: string): value is Environment => {
  return EnvironmentValues.includes(value as Environment);
};
export const getEnvConfig = () => {
  return {
    environment: process.env.NX_GENEO_ENV || 'dev',
    userDataBucket:
      process.env.NX_USER_DATA_BUCKET || 'geneo-staging-geneo-user-data',
    resourceContentBucket:
      process.env.NX_RESOURCE_CONTENT_BUCKET || 'geneo-content-resource-files',
    processedMediaBucket:
      process.env.NX_PROCESSED_MEDIA_BUCKET || 'geneo-content-processed-media',
    schoolnetCdnImagesBucket:
      process.env.NX_SCHOOLNET_CDN_IMAGES_BUCKET || 'schoolnet-cdn-images',
    schoolnetStaticAssetBucket:
      process.env.NX_ASSETS_MEDIA_BUCKET || 'schoolnet_app_assets',
    firebaseConfig: {
      apiKey: process.env.NX_FIREBASE_API_KEY,
      authDomain: process.env.NX_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.NX_FIREBASE_PROJECT_ID,
      storageBucket: process.env.NX_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.NX_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.NX_FIREBASE_APP_ID,
      measurementId: process.env.NX_FIREBASE_MEASUREMENT_ID,
    },
    firebaseVapidKey: process.env.NX_VAPID_KEY,
    mcbSsoClientId: process.env.NX_MCB_SSO_CLIENT_ID,
    mcbRedirectUrl: process.env.NX_MCB_REDIRECT_URL,
    sentry: {
      dsn: process.env.NX_SENTRY_DSN,
      enabled: process.env.NX_SENTRY_ENABLED === 'true',
    },
  };
};

export const isAiDebuggingEnabled = () => {
  const nxGeneoEnv = process.env.NX_GENEO_ENV || 'local';
  const environment = (
    isEnvironmentValue(nxGeneoEnv) ? nxGeneoEnv : 'local'
  ) as Environment;
  // if (environment === 'local' || environment === 'dev') {
  //   return true;
  // } else {
  //   return false;
  // }
  return false;
};

export const amplitudeConfig = {
  appVersion: process.env.NX_GENEO_FRONTEND_VERSION || '1.0.0',
  appStateVersion: '1.0.0',
  amplitudeApiKey:
    process.env.NX_AMPLITUDE_API_KEY || 'ca516e4ce18feb226c6c35170444d8e4',
  project: 'geneo-test',
};
export const AMPLITUDE_API_KEY =
  window.location.hostname === 'localhost'
    ? 'b8bcff61c81ab4b094f3e4a3df12ed9e'
    : process.env.NX_AMPLITUDE_API_KEY || 'b8bcff61c81ab4b094f3e4a3df12ed9e';
export const AUTOMATIC_AMPLITUDE_ANALYTICS_CONSENT =
  process.env.NX_AUTOMATIC_AMPLITUDE_ANALYTICS_CONSENT === 'true';

/**
 * Geneo IoT - the block editor / simulator embedded for practical resources.
 *
 * `IOT_ORIGIN` is a security control, not just a URL: every message we send to
 * the frame is targeted at it and every message we accept is checked against it
 * with exact string equality. So it must stay a bare origin - no path, no
 * trailing slash - which is the form `MessageEvent.origin` always takes.
 */
export const IOT_ORIGIN = (
  process.env.NX_IOT_ORIGIN || 'https://code.schoolnetindia.tech'
).replace(/\/+$/, '');
/**
 * Path Geneo IoT is served under, for deployments where it shares an origin
 * with us rather than having its own host: offline serves it at `/iot`, so the
 * frame URL needs a path while `IOT_ORIGIN` above must stay bare. Empty (the
 * hosted default) keeps the frame at the origin root. Normalised to a leading
 * slash and no trailing slash.
 */
export const IOT_BASE_PATH = (process.env.NX_IOT_BASE_PATH || '')
  .trim()
  .replace(/\/+$/, '')
  .replace(/^(?!\/)(.+)$/, '/$1');
/** `embed=1` tells Geneo IoT to hide its own save/open/export chrome. */
export const IOT_SRC = `${IOT_ORIGIN}${IOT_BASE_PATH}/?embed=1`;
/** Version of the host <-> frame message contract. Bump on breaking changes. */
export const IOT_PROTOCOL = 1;

export const PAL_BASE_URL =
  process.env.NX_PAL_API_IS_LOCAL === 'true' ? '' : '/pal';

export const isPalAPILocal = process.env.NX_PAL_API_IS_LOCAL === 'true';
